export type PopularBlock = {
  mostReviewd?: string;
  mostVisited?: string;
  mostContacted?: string;
  mostReviewed?: string;
};

const pickCountryKey = (selectedCountry?: string, countryCode?: string | null) => {
  // Prefer explicit selectedCountry (from CountryContext) and return uppercase keys to match config
  if (selectedCountry) {
    const s = selectedCountry.toUpperCase();
    if (s === 'SVIZZERA' || s === 'SVIZZERA') return 'SVIZZERA';
    return 'ITALIA';
  }

  // Fallback to visitor country code (useful when context isn't set yet)
  if (countryCode) {
    const c = countryCode.toLowerCase();
    if (c === 'ch') return 'SVIZZERA';
    if (c === 'it') return 'ITALIA';
  }

  return 'ITALIA';
};

export const loadMostPopularConfig = async (selectedCountry?: string, countryCode?: string | null): Promise<PopularBlock | null> => {
  try {
    const res = await fetch('/mostPopularConfig.json');
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || typeof data !== 'object') return null;
    const key = pickCountryKey(selectedCountry, countryCode);
    const block = (data as any)[key] || null;
    // If the JSON was already the flat object (backwards compat), return it
    if (!block && (data.mostVisited || data.mostContacted || data.mostReviewd || data.mostReviewed)) {
      return data as PopularBlock;
    }
    return block as PopularBlock | null;
  } catch (e) {
    return null;
  }
};

